// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6df867e7","453":"13e12a20","732":"e9af98fb"}[chunkId] + ".chunk.js";
};